import { render, staticRenderFns } from "./PopupRiskAssessmentDB.vue?vue&type=template&id=f3d332bc&scoped=true"
import script from "./PopupRiskAssessmentDB.vue?vue&type=script&lang=js"
export * from "./PopupRiskAssessmentDB.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskAssessmentDB.vue?vue&type=style&index=0&id=f3d332bc&prod&scoped=true&lang=scss"
import style1 from "./PopupRiskAssessmentDB.vue?vue&type=style&index=1&id=f3d332bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d332bc",
  null
  
)

export default component.exports